<script lang="ts" setup>
  type Props = {
    text?: string
    displayed: boolean
  }

  const props = defineProps<Props>()
</script>

<template>
  <div
    class="c-loader"
    :class="{ 'is-displayed': props.displayed }"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="75"
      height="75"
      viewBox="0 0 47.243 47.243"
    >
      <g>
        <path
          fill="#1a2c36"
          d="M275.187 262.455l-8.957 4.028a.6.6 0 0 0-.3.3l-4.039 8.935a.607.607 0 0 1-1.112-.024l-9.127-22.676a.606.606 0 0 1 .788-.786l22.726 9.11a.6.6 0 0 1 .023 1.112z"
          transform="translate(-228.305 -228.829)"
        />
        <path
          fill="#11d199"
          d="M20.39 30.174a7.119 7.119 0 1 1 9.383-9.912L45.6 26.6a11.365 11.365 0 0 0 1.728-6.439c0-5.28-5-8.878-7.041-11.588C37.767 5.239 36 .774 29.721.144c-7.358-.737-8.986 2.024-13.91 5.266-4.447 2.93-9.2 1.76-13.689 7.833-5.105 6.9 1.019 12.907.834 19.732-.278 10.419 8.565 16.376 19.68 13.618a13.868 13.868 0 0 0 3.75-1.535z"
        />
      </g>
    </svg>
    <p v-if="text">
      <span>{{ text }}</span>
    </p>
  </div>
</template>

<style scoped>
.c-loader {
  position: absolute;
  z-index: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #eef0f1;
  inset: 0;
  opacity: 0;
  transition: visibility 250ms ease-out, opacity 250ms ease-out, z-index 250ms ease-out;
  visibility: hidden;

  &.is-fixed {
    position: fixed;
    width: 100vw;
    height: 100vh;
  }

  &.is-displayed {
    z-index: 100;
    opacity: 1;
    visibility: visible;
  }

  &.is-blur {
    backdrop-filter: blur(2px);
    background-color: rgb(255 255 255 / 75%);
  }

  svg {
    margin: auto;
    animation: infinite 2s ease-in glow;
  }

  p {
    margin-top: 2em;

    span {
      color: var(--color-secondary);
      font-family: Bariol, sans-serif;
      font-size: 1.5em;
      font-weight: bold;
    }
  }
}

@keyframes glow {
  0% {
    transform: scale(0.8);
  }

  25% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.8);
  }

  100% {
    transform: scale(0.8);
  }
}
</style>
